import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'

type WorkspaceFieldToUpdate = 'name' | 'parent' | 'projectCode'
const isOpen = atom(false)
const workspaceId = atom<string>('')
const parentId = atom<string | null | undefined>('')
const projectCode = atom<string | null | undefined>('')
const workspaceName = atom('')
const fieldsToUpdate = atom<WorkspaceFieldToUpdate[]>([])
const isSameOrgOnly = atom(false)

export function useEditWorkspaceModalValues() {
  return {
    isOpen: useAtomValue(isOpen),
    workspaceId: useAtomValue(workspaceId),
    parentId: useAtomValue(parentId),
    projectCode: useAtomValue(projectCode),
    workspaceName: useAtomValue(workspaceName),
    fieldsToUpdate: useAtomValue(fieldsToUpdate),
    isSameOrgOnly: useAtomValue(isSameOrgOnly),
  }
}

export function useShowEditWorkspaceModal() {
  const setIsOpen = useSetAtom(isOpen)
  const setWorkspaceId = useSetAtom(workspaceId)
  const setParentId = useSetAtom(parentId)
  const setProjectCode = useSetAtom(projectCode)
  const setWorkspaceName = useSetAtom(workspaceName)
  const setFieldsToUpdate = useSetAtom(fieldsToUpdate)
  const setIsSameOrgOnly = useSetAtom(isSameOrgOnly)

  return useCallback(
    ({
      workspaceId,
      parentId,
      projectCode,
      workspaceName,
      fieldsToUpdate,
      isSameOrgOnly,
    }: {
      workspaceId: string
      parentId?: string | null
      projectCode?: string | null
      workspaceName: string
      fieldsToUpdate: WorkspaceFieldToUpdate[]
      isSameOrgOnly?: boolean
    }) => {
      setIsOpen(true)
      setWorkspaceId(workspaceId)
      setParentId(parentId)
      setProjectCode(projectCode)
      setWorkspaceName(workspaceName)
      setFieldsToUpdate(fieldsToUpdate)
      setIsSameOrgOnly(isSameOrgOnly ?? false)
    },
    []
  )
}

export function useCloseEditWorkspaceModal() {
  const setIsOpen = useSetAtom(isOpen)
  const setWorkspaceId = useSetAtom(workspaceId)
  const setParentId = useSetAtom(parentId)
  const setProjectCode = useSetAtom(projectCode)
  const setWorkspaceName = useSetAtom(workspaceName)
  const setFieldsToUpdate = useSetAtom(fieldsToUpdate)
  const setIsSameOrgOnly = useSetAtom(isSameOrgOnly)

  return useCallback(() => {
    setIsOpen(false)
    setWorkspaceId('')
    setParentId('')
    setProjectCode('')
    setWorkspaceName('')
    setFieldsToUpdate([])
    setIsSameOrgOnly(false)
  }, [])
}
